import React, { useState } from "react";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  Avatar,
  Button,
  // Modal,
  Stack,
  styled,
  Typography
} from "@mui/material";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";
import { useDealActions } from "store";
import { IOpportunities } from "store/types";

import { OpportunityPdfPreview } from "./OpportunityPdfPreview";

const CharacteristicText = styled(Typography)({
  fontSize: "12px",
  lineHeight: "16px",
  color: "#071F35",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
});

const CharacteristicContainer = styled(Stack)({
  bgcolor: "#ECF1F8",
  p: "4px 8px",
  borderRadius: "4px",
  flexDirection: "row",
  gap: "4px",
  overflow: "hidden"
});

interface Props {
  isExpanded: boolean;
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  opportunity: IOpportunities;
}

export const Banner: React.FC<Props> = ({ isExpanded, setIsExpanded, opportunity }) => {
  // const [isPlaceOnMarketModalOpen, setIsPlaceOnMarketModalOpen] = useState<number | null>(null);
  const { sendOpportunityEventAction } = useDealActions();
  const [isPdfPreviewOpen, setIsPdfPreviewOpen] = useState(false);
  const { deal_title, asset_class, vintage, geography, description, deal_logo } = opportunity;

  return (
    <Stack
      sx={{
        width: "100%",
        flexDirection: "row",
        alignItems: "center",
        bgcolor: "#F6F8FC",
        p: "16px",
        borderRadius: "8px",
        gap: "16px"
      }}
    >
      <Avatar alt="Deal's logo" src={deal_logo || ""} sx={{ width: "52px", height: "52px", borderRadius: "8px" }} />
      <Stack sx={{ flexGrow: 1, overflow: "hidden", flexShrink: 0 }}>
        <Typography
          sx={{
            fontSize: "18px",
            lineHeight: "24px",
            fontWeight: 700,
            color: "#071F35",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}
        >
          {deal_title}
        </Typography>
        <Stack sx={{ flexDirection: "row", gap: "10px" }}>
          <CharacteristicContainer>
            <CharacteristicText>Asset Class:</CharacteristicText>
            <CharacteristicText sx={{ fontWeight: 700 }}>{asset_class || "-"}</CharacteristicText>
          </CharacteristicContainer>
          <CharacteristicContainer>
            <CharacteristicText>Vintage:</CharacteristicText>
            <CharacteristicText sx={{ fontWeight: 700 }}>{vintage || "-"}</CharacteristicText>
          </CharacteristicContainer>
          <CharacteristicContainer>
            <CharacteristicText
            // onClick={() => setIsPlaceOnMarketModalOpen(6414)}
            >
              Geography:
            </CharacteristicText>
            <CharacteristicText sx={{ fontWeight: 700 }}>{geography || "-"}</CharacteristicText>
          </CharacteristicContainer>
        </Stack>
      </Stack>
      <MaterialTooltip isShow title={description} placement="top">
        <Typography
          sx={{
            fontSize: "15px",
            lineHeight: "20px",
            fontWeight: 400,
            color: "#071F35",
            minWidth: 200,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}
        >
          {description}
        </Typography>
      </MaterialTooltip>
      <Stack sx={{ gap: "8px" }}>
        <Button
          onClick={() => {
            sendOpportunityEventAction({ id: opportunity.id, event: "viewed" });
            setIsPdfPreviewOpen(true);
          }}
          sx={{ whiteSpace: "nowrap" }}
          size="sm"
          variant="contained"
        >
          View Opportunity
        </Button>
        {Boolean(Object.keys(opportunity.graphs).length) && (
          <Button
            onClick={() => {
              !isExpanded && sendOpportunityEventAction({ id: opportunity.id, event: "compared" });
              setIsExpanded((prev) => !prev);
            }}
            sx={{ whiteSpace: "nowrap", color: "#26A6AE" }}
            endIcon={<ArrowDropDownIcon />}
            size="sm"
          >
            Compare to Portfolio
          </Button>
        )}
      </Stack>
      <OpportunityPdfPreview
        opportunityData={opportunity}
        onClose={() => setIsPdfPreviewOpen(false)}
        isOpen={isPdfPreviewOpen}
      />
    </Stack>
  );
};
